'use client';

import { c as _c } from "react/compiler-runtime";
import type { OnrampClient } from '@morfi/onramp-sdk';
import { useFundingAuthenticationTerms } from '@morfi/onramp-sdk/react';
import { useTranslations } from 'next-intl';
import { type ReactNode, useEffect } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { logger } from '@/lib/telemetry/logger';
import { FundingLoading } from '../shared/funding-loading';
export function FundingAuthenticationTerms(t0) {
  const $ = _c(50);
  const {
    client,
    busy,
    error,
    onAccept
  } = t0;
  const t = useTranslations("onramp");
  const terms = useFundingAuthenticationTerms(client);
  let t1;
  let t2;
  if ($[0] !== terms.failed) {
    t1 = () => {
      if (terms.failed) {
        logger.warn("onramp.auth_terms_failed");
      }
    };
    t2 = [terms.failed];
    $[0] = terms.failed;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (terms.loading) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <FundingLoading />;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  if (terms.failed || !terms.consent) {
    let t3;
    if ($[4] !== t) {
      t3 = t("consent_unavailable");
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t3) {
      t4 = <p>{t3}</p>;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    const t5 = terms.retry;
    let t6;
    if ($[8] !== t) {
      t6 = t("retry");
      $[8] = t;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] !== t6 || $[11] !== terms.retry) {
      t7 = <AnimatedButton onClick={t5}>{t6}</AnimatedButton>;
      $[10] = t6;
      $[11] = terms.retry;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== t4 || $[14] !== t7) {
      t8 = <div role="alert" className="flex flex-col gap-3">{t4}{t7}</div>;
      $[13] = t4;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  const consent = terms.consent;
  let t3;
  if ($[16] !== consent.text) {
    t3 = <p className="text-body">{consent.text}</p>;
    $[16] = consent.text;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  const t4 = consent.termsUrl;
  let t5;
  if ($[18] !== t) {
    t5 = t("moonpay_terms");
    $[18] = t;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== consent.termsUrl || $[21] !== t5) {
    t6 = <a href={t4} target="_blank" rel="noopener noreferrer" className="underline">{t5}</a>;
    $[20] = consent.termsUrl;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  const t7 = consent.privacyUrl;
  let t8;
  if ($[23] !== t) {
    t8 = t("privacy_policy");
    $[23] = t;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== consent.privacyUrl || $[26] !== t8) {
    t9 = <a href={t7} target="_blank" rel="noopener noreferrer" className="underline">{t8}</a>;
    $[25] = consent.privacyUrl;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t6 || $[29] !== t9) {
    t10 = <p className="text-caption text-foreground-secondary">{t6}{" \xB7 "}{t9}</p>;
    $[28] = t6;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== error || $[32] !== t) {
    t11 = error ? <p role="alert">{t("provider_unavailable")}</p> : null;
    $[31] = error;
    $[32] = t;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const t12 = busy || !onAccept;
  let t13;
  if ($[34] !== consent.version || $[35] !== onAccept) {
    t13 = () => {
      onAccept?.(consent.version);
    };
    $[34] = consent.version;
    $[35] = onAccept;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== busy || $[38] !== t) {
    t14 = busy ? t("checking") : t("continue");
    $[37] = busy;
    $[38] = t;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== busy || $[41] !== t12 || $[42] !== t13 || $[43] !== t14) {
    t15 = <AnimatedButton loading={busy} disabled={t12} onClick={t13}>{t14}</AnimatedButton>;
    $[40] = busy;
    $[41] = t12;
    $[42] = t13;
    $[43] = t14;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== t10 || $[46] !== t11 || $[47] !== t15 || $[48] !== t3) {
    t16 = <div className="flex flex-col gap-4">{t3}{t10}{t11}{t15}</div>;
    $[45] = t10;
    $[46] = t11;
    $[47] = t15;
    $[48] = t3;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  return t16;
}